// components/SocialMediaAds.tsx
import { motion, AnimatePresence } from "framer-motion";
import { Facebook, Linkedin, Globe, Instagram } from "lucide-react";
import * as React from "react";

const ads = [
  {
    name: "LinkedIn",
    icon: <Linkedin className="w-7 h-7" />,
    color: "bg-blue-700",
    handle: "ROBOTWALA",
  },
  {
    name: "Instagram",
    icon: <Instagram className="w-7 h-7" />,
    color: "bg-[#DC01B2]",
    handle: "robotwala.edtech",
  },
  {
    name: "Facebook",
    icon: <Facebook className="w-7 h-7" />,
    color: "bg-blue-700",
    handle: "Robotwala",
  },
  {
    name: "Our Website",
    icon: <Globe className="w-7 h-7" />,
    color: "bg-red-700",
    handle: "https://www.robotwala.org/",
  },
];

export default function SocialMediaAds() {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-y-0 right-5 bottom-36 flex items-center z-50 pointer-events-none">
      <AnimatePresence mode="wait">
        <motion.a
          key={index}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ x: 400, opacity: 0 }}
          animate={{ x: 20, opacity: 1 }}
          exit={{ x: 400, opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className={`pointer-events-auto flex items-center gap-4 px-1 py-1 rounded-l-xl  text-white font-bold border-l-4 border-white/50
            ${ads[index].color} 
            backdrop-blur-xl bg-opacity-90`}
          // whileHover={{ x: 10, scale: 1.05 }}
        >
          {/* Icon */}
          <div className="bg-white/30 rounded-full backdrop-blur-md">
            {ads[index].icon}
          </div>

          {/* Text */}
          <div className="leading-tight">
            <p className="text-xs opacity-90">Follow us on</p>
            <p className="text-sm">{ads[index].handle}</p>
          </div>

          {/* Tiny live dot */}
          <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse" />
        </motion.a>
      </AnimatePresence>
    </div>
  );
}
